<template>
  <v-app>
    <v-content class="bg">
      <router-view></router-view>
    </v-content>
    <AppBar v-if="$route.path!='/mainpage'"/>
    <Loading ref="loading" />
  </v-app>
</template>
<script>
import general from "@/js/general.js";
export default {
  name: "app",
  components: {
    AppBar: () => import("@/components/AppBar.vue"),
  },
  props: [],
  data() {
    return {
    };
  },
  computed: {},
  methods: {
    async menuClick(route) {
      this.$store.commit("resetState");
      this.$router.replace({ name: route });
    },
    backMenu() {
      window.location.href = "https://stat.bora.dopa.go.th/stat/statnew/statMenu/newStat/stat/";
    },
  },
  async mounted() {
     if (window.location.hostname == "localhost") {
      document.cookie ='token=eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJwaWQiOjMxMDEyMDI5MTcxMjEsImNpZCI6IjIzMjYwODA3Mjg5NjQ1MjciLCJpYXQiOjE1Njg4ODUwOTl9.xC_UGv5ou8GrGRe3X4nnMhozltMvfPrBoW2PXZxDKj4'
    }
    let state = this.$store.state;
    state.loading = this.$refs.loading;

    let response = await general.getSysDate();
    state.sysDate = response;
    this.systemDate = general.formatDateToDisplay(state.sysDate);
    
    if(window.innerWidth < 768){
       state.isMobile = true
    }
    try {
      state.listsCC = await general.getListsCC();
    } catch (error) {
      await this.$refs.alertBox.showAlert(
        "ไม่สามารถติดต่อฐานข้อมูลตารางรหัสได้",
        "error",
        "แจ้งให้ทราบ"
      );
      this.backMenu();
    }
    this.menuClick("home");
  },
};
</script>

